import { Injectable } from '@angular/core';
import { GetUserProfileGQL, EditUserProfileGQL } from '../generated/cloudapigql';
import MD5 from 'crypto-js/md5';

export interface UserProfile{
    name:string;
    contactNo:string;
    email:string;
    avatarSrc:string;
}

@Injectable()
export class ProfileService {
    public user: UserProfile = {} as UserProfile;

    constructor(
        private _getUserProfileGQL: GetUserProfileGQL,
        private _editUserProfileGQL: EditUserProfileGQL,

    ) {
        // this.getUserProfile();
    }

    initProfileData(){
        this.getUserProfile().subscribe(x => {
            this.user = x.data.getUserProfile as UserProfile;
            this.user.avatarSrc = `https://www.gravatar.com/avatar/${MD5(this.user.email)}?s=150&d=identicon`;
        });
    }

    getUserProfile() {
        return this._getUserProfileGQL.fetch();
    }

    async updateUserContact(name:string,contactNo:string) {
        let  updateResult = await this._editUserProfileGQL.mutate({
            input:{
                name:name,
                contactNo:contactNo
            }
        }).toPromise();
        this.user = updateResult.data.editUserProfileContact as UserProfile;
        this.user.avatarSrc = `https://www.gravatar.com/avatar/${MD5(this.user.email)}?s=150&d=identicon`;

        return  updateResult.data.editUserProfileContact;
    }
}
